import { v4 as uuidv4 } from 'uuid';
import { actionTypes } from '../Components/pages/jobs/types';
import colors from '../scss/colors';
import configData from '../config.json';

const mobileWidth = 767;
const qtyTopSkills = 5;
const minQtyTopSkills = 3;
const maxMoneyValue = 99999999999999;

const jobAlerts = (t, count, total) => [
  { label: t('jobs.alerts.create'), disabled: count >= 5, action: 'create', key: uuidv4(10) },
  { label: t('jobs.alerts.set'), disabled: count >= 5, action: 'set', key: uuidv4(10) },
  { label: `${t('jobs.alerts.view')} (${count} / ${total})`, disabled: false, action: 'view', key: uuidv4(10) }
];

const savedJobOptions = (t, item) => [
  { label: t('common.general.view'), disabled: !item?.Job?.IsActive, action: actionTypes.VIEW, key: uuidv4(10) },
  { label: t('common.general.unsave'), disabled: false, action: actionTypes.UNSAVE, key: uuidv4(10) },
  { label: t('common.general.apply'), disabled: !item?.Job?.IsActive, action: actionTypes.APPLY, key: uuidv4(10) }
];

const phoneTypes = [
  { id: 0, value: 'Mobile', label: 'Mobile' },
  { id: 1, value: 'Work', label: 'Work' },
  { id: 2, value: 'Home', label: 'Home' }
];

const Currency = [
  'AED',
  'AOA',
  'ARG',
  'ARS',
  'AUD',
  'AZN',
  'BHD',
  'BRL',
  'CAD',
  'CFA',
  'COP',
  'DKK',
  'EGP',
  'EUR',
  'GBP',
  'GEL',
  'GHS',
  'IDR',
  'INR',
  'IQD',
  'JPY',
  'KRW',
  'KWD',
  'KZT',
  'MXN',
  'MYR',
  'MZN',
  'NOK',
  'NZD',
  'OMR',
  'PGK',
  'PHP',
  'QAR',
  'RMB',
  'RUB',
  'SAR',
  'SEK',
  'SGD',
  'THB',
  'TTD',
  'TWD',
  'USD',
  'VEN',
  'VND',
  'ZAR'
];

const MAX_CV_FILE_SIZE = 10485760;

const CV_FILE_ALLOWED_FORMATS = ['docx', 'doc', 'pdf'];

const maxMobileSize = 768;
const MOBILE_BREAKPOINT = 576;
const layoutResponsive = 430;

const responsiveSizeTIFO = 600;

const responsiveSizeTimesheet = 1024;

const validationMessages = (t) => {
  return {
    CV_ALLOWED_FORMATS: t('profile.validations.CV_ALLOWED_FORMATS'),
    ALLOWED_FORMATS: t('profile.validations.ALLOWED_FORMATS'),
    CV_ONLY_ONE_FILE: t('profile.validations.CV_ONLY_ONE_FILE'),
    CV_ALLOWED_FILE_SIZE: t('profile.validations.CV_ALLOWED_FILE_SIZE'),
    ALLOWED_FILE_SIZE: t('profile.validations.ALLOWED_FILE_SIZE'),
    WORK_REQ_TITLE: t('profile.validations.WORK_REQ_TITLE'),
    WORK_REQ_COMPANY: t('profile.validations.WORK_REQ_COMPANY'),
    WORK_REQ_DESCRIPTION: t('profile.validations.WORK_REQ_DESCRIPTION'),
    WORK_REQ_BIOGRAPHY: t('profile.validations.WORK_REQ_BIOGRAPHY'),
    LOCATION_REQ: t('dashboard.createtimesheet.locationrequired'),
    WORKTYPE_REQ: t('dashboard.createtimesheet.worktyperequired'),
    WORK_FORBIDDEN_SYMBOLS: t('profile.validations.WORK_FORBIDDEN_SYMBOLS'),
    WORK_CURRENTLY: t('profile.validations.WORK_CURRENTLY'),
    DATE_REQ_END_DATE: t('profile.validations.DATE_REQ_END_DATE'),
    DATE_REQ_START_DATE: t('profile.validations.DATE_REQ_START_DATE'),
    DATE_START_AFTER_END: t('profile.validations.DATE_START_AFTER_END'),
    DATE_END_BEFORE_START: t('profile.validations.DATE_END_BEFORE_START'),
    EDUCATION_REQ_SCHOOL: t('profile.validations.EDUCATION_REQ_SCHOOL'),
    EDUCATION_REQ_DEGREE: t('profile.validations.EDUCATION_REQ_DEGREE'),
    EDUCATION_REQ_FOS: t('profile.validations.EDUCATION_REQ_FOS'),
    TRAINING_REQ_TYPE: t('profile.validations.TRAINING_REQ_TYPE'),
    TRAINING_REQ_CERT_ID: t('profile.validations.TRAINING_REQ_CERT_ID'),
    TOP_SKILLS_MAX: t('profile.validations.TOP_SKILLS_MAX'),
    TOP_SKILLS_MIN: t('profile.validations.TOP_SKILLS_MIN'),
    PHONE_NUMBER_REQ: t('profile.validations.PHONE_NUMBER_REQ'),
    PHONE_NUMBER_INVALID: t('profile.validations.PHONE_NUMBER_INVALID'),
    COUNTRY_REQ: t('profile.validations.COUNTRY_REQ'),
    COUNTRY_MIN_CHAR: t('profile.validations.COUNTRY_MIN_CHAR'),
    CITY_REQ: t('profile.validations.CITY_REQ'),
    CITY_MIN_CHAR: t('profile.validations.CITY_MIN_CHAR'),
    STATE_MIN_CHAR: t('profile.validations.STATE_MIN_CHAR'),
    INFO_REQ: t('profile.validations.INFO_REQ'),
    INDUSTRY_REQ: t('profile.validations.INDUSTRY_REQ'),
    FUNCTION_REQ: t('profile.validations.FUNCTION_REQ'),
    TYPE_WORK_CHOOSE_ONE: t('profile.validations.TYPE_WORK_CHOOSE_ONE'),
    CURRENCY_REQ: t('profile.validations.CURRENCY_REQ'),
    SALARY_REQ: t('profile.validations.SALARY_REQ'),
    ONLY_NUMBERS: t('profile.validations.ONLY_NUMBERS'),
    HOURLY_OR_DAILY: t('profile.validations.HOURLY_OR_DAILY'),
    EMAIL_INVALID: t('profile.validations.EMAIL_INVALID'),
    EMAIL_REQUIRED: t('profile.validations.EMAIL_REQUIRED'),
    USERNAME_REQUIRED: t('profile.validations.USERNAME_REQUIRED'),
    CURRENT_WORK_MAX: t('profile.validations.CURRENT_WORK_MAX'),
    CURRENT_EDUCATION_MAX: t('profile.validations.CURRENT_EDUCATION_MAX'),
    INIT_SKILLS_LONGER_THAN: t('profile.validations.INIT_SKILLS_LONGER_THAN'),
    VALIDATION_LOCATION_COUNTRY: t('profile.validations.VALIDATION_LOCATION_COUNTRY'),
    VALIDATION_LOCATION_STATE: t('profile.validations.VALIDATION_LOCATION_STATE'),
    VALIDATION_LOCATION_CITY: t('profile.validations.VALIDATION_LOCATION_CITY'),
    CV_REQUIRED: t('profile.validations.CV_REQUIRED'),
    PROFILE_BUILDER_TWO_COMMON_ERROR: t('profile.validations.PROFILE_BUILDER_TWO_COMMON_ERROR'),
    SKILLS_MIN_CHAR_SEARCH: t('profile.validations.SKILLS_MIN_CHAR_SEARCH'),
    MAX_MONEY_VALUE: t('profile.validations.MAX_MONEY_VALUE')
  };
};

const maxSymbolQTY = {
  SCHOOL: 500,
  DEGREE: 100,
  FIELD_OF_STUDY: 100,
  TYPE: 500,
  CERTIFICATE_ID: 100,
  SKILL: 50,
  PHONE: 15
};

const minSymbolQTY = {
  COUNTRY: 3,
  CITY: 3,
  STATE: 3,
  PHONE: 4
};

const deleteModalConfigs = (t) => {
  return {
    works: {
      title: t('profile.modals.works.title'),
      text: t('profile.modals.works.text')
    },
    educations: {
      title: t('profile.modals.educations.title'),
      text: t('profile.modals.educations.title')
    },
    trainings: {
      title: t('profile.modals.trainings.title'),
      text: t('profile.modals.trainings.title')
    }
  };
};

const languages = [
  {
    key: 'en',
    value: 'English'
  },
  {
    key: 'es',
    value: 'Spanish'
  },
  {
    key: 'fr',
    value: 'French'
  },
  {
    key: 'pt',
    value: 'Portuguese'
  },
  {
    key: 'ms',
    value: 'Bahasa'
  }
];
const errorsMessages = (t) => {
  return {
    NETWORK_ERROR: t('common.errors.NETWORK_ERROR')
  };
};

const MAX_CURRENT_WORKS = 2;
const MAX_CURRENT_EDUCATIONS = 2;
const APPROVE_ALL_EXPENSES_COUNT = 6;

const appNotificationsTypes = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error'
};

const appNotificationsConfigs = {
  CREATE_SUCCESS: (t) => ({
    type: appNotificationsTypes.SUCCESS,
    message: t('notifications.alert_create_success'),
    duration: 3000
  }),
  UPDATE_SUCCESS: (t) => ({
    type: appNotificationsTypes.SUCCESS,
    message: t('notifications.alert_update_success'),
    duration: 3000
  }),
  DELETE_SUCCESS: (t) => ({
    type: appNotificationsTypes.SUCCESS,
    message: t('notifications.alert_delete_success'),
    duration: 3000
  }),
  CREATE_ERROR: (createError) => ({
    type: appNotificationsTypes.ERROR,
    message: createError,
    duration: 3000
  }),
  UPDATE_ERROR: (updateError) => ({
    type: appNotificationsTypes.ERROR,
    message: updateError,
    duration: 3000
  }),
  DELETE_ERROR: (deleteError) => ({
    type: appNotificationsTypes.ERROR,
    message: deleteError,
    duration: 3000
  })
};

const userExistConfig = {
  CREATE_SUCCESS: () => ({
    type: appNotificationsTypes.ERROR,
    message: 'User Exists and Please proceed with login to apply',
    duration: 3000
  }),
  JOB_ALREADY_APPLIED: () => ({
    type: appNotificationsTypes.ERROR,
    message: 'You have already applied for this job',
    duration: 3000
  }),
  SERVER_ERROR: () => ({
    type: appNotificationsTypes.ERROR,
    message: 'Something went wrong, Please try again later',
    duration: 3000
  })
};

const JOB_STATUS = {
  APPLIED: 'Applied',
  SUBMITTED: 'Submitted to Client',
  INTERVIEW: 'Interview',
  OFFER_EXTENDED: 'Offer Extended',
  CLOSED: 'Closed'
};

const benefits = {
  AI: 'aijobmatching',
  EASY_APPLY: 'easyapply',
  APP_TRACKING: 'applicationtracking',
  AUTO_JOB_ALERTS: 'automatedjobalerts'
};

const timesheetsStatuses = (t, isApprover = false) => ({
  processed: {
    label: t('dashboard.statuses.processed'),
    color: colors.PROCESSED,
    textColor: colors.WHITE,
    apiStatus: 'Processed'
  },
  submitted: {
    label: isApprover ? t('dashboard.statuses.pending') : t('dashboard.statuses.submitted'),
    color: colors.ORANGE_LIGHT,
    textColor: colors.WHITE,
    apiStatus: 'Submitted'
  },
  approved: {
    label: t('dashboard.statuses.approved'),
    color: colors.GREEN_LIGHT,
    textColor: colors.WHITE,
    apiStatus: 'Approved'
  },
  rejected: {
    label: t('dashboard.statuses.rejected'),
    color: colors.REJECTED,
    textColor: colors.WHITE,
    apiStatus: 'Rejected'
  },
  draft: {
    label: t('dashboard.statuses.draft'),
    color: colors.LIGHT_GREY,
    textColor: colors.DARKEST_GREY,
    apiStatus: 'Draft'
  }
});

const notificationStatuses = (t, isApprover = false) => ({
  registered: {
    label: t('dashboard.statuses.registered'),
    color: colors.PROCESSED,
    textColor: colors.WHITE,
    apiStatus: 'Registered'
  },
  draft: {
    label: t('dashboard.statuses.draft'),
    color: colors.LIGHT_GREY,
    textColor: colors.DARKEST_GREY,
    apiStatus: 'Draft'
  }
});

const months = (t) => [
  t('common.general.monthes.january'),
  t('common.general.monthes.february'),
  t('common.general.monthes.march'),
  t('common.general.monthes.april'),
  t('common.general.monthes.may'),
  t('common.general.monthes.june'),
  t('common.general.monthes.july'),
  t('common.general.monthes.august'),
  t('common.general.monthes.september'),
  t('common.general.monthes.october'),
  t('common.general.monthes.november'),
  t('common.general.monthes.december')
];

const monthsShort = (t) => [
  t('common.general.monthesshort.jan'),
  t('common.general.monthesshort.feb'),
  t('common.general.monthesshort.mar'),
  t('common.general.monthesshort.apr'),
  t('common.general.monthesshort.may'),
  t('common.general.monthesshort.jun'),
  t('common.general.monthesshort.jul'),
  t('common.general.monthesshort.aug'),
  t('common.general.monthesshort.sep'),
  t('common.general.monthesshort.oct'),
  t('common.general.monthesshort.nov'),
  t('common.general.monthesshort.dec')
];

const tAndEFilters = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  LOCATION: 'location',
  STATUS: 'status',
  CONTRACTOR: 'contractor',
  CLAIM: 'claim'
};

const contractorFilters = [tAndEFilters.WEEK, tAndEFilters.MONTH, tAndEFilters.LOCATION, tAndEFilters.STATUS];

const approverFilters = [
  tAndEFilters.WEEK,
  tAndEFilters.MONTH,
  tAndEFilters.CONTRACTOR,
  tAndEFilters.LOCATION,
  tAndEFilters.STATUS
];

const contractorExpensesFilters = [tAndEFilters.DAY, tAndEFilters.MONTH, tAndEFilters.CLAIM, tAndEFilters.STATUS];

const approverExpensesFilters = [
  tAndEFilters.DAY,
  tAndEFilters.MONTH,
  tAndEFilters.CLAIM,
  tAndEFilters.CONTRACTOR,
  tAndEFilters.STATUS
];

const calendarTypes = {
  WEEK: 'week',
  DAY: 'day'
};

const globalPageSize = 6;

const qtyToShowComment = 190;
const qtyAllowedForComment = 200;

const appAreas = {
  TIMESHEETS: 'timesheets',
  EXPENSES: 'expenses'
};

const appConfigVariableValues = {
  DOMAIN: configData['AzureTandEDocumentUpload:Domain'],
  BLOB_CONTAINER: configData['AzureExpenseDocumentUpload:BlobContainerName'],
  SASS_TOKEN: configData['AzureTandEDocumentUpload:SasToken']
};

const imageFileTypes = ['jpeg', 'jpg', 'png'];

export {
  maxMobileSize,
  MOBILE_BREAKPOINT,
  qtyTopSkills,
  minQtyTopSkills,
  Currency,
  phoneTypes,
  responsiveSizeTIFO,
  responsiveSizeTimesheet,
  errorsMessages,
  validationMessages,
  maxSymbolQTY,
  minSymbolQTY,
  MAX_CV_FILE_SIZE,
  CV_FILE_ALLOWED_FORMATS,
  MAX_CURRENT_WORKS,
  MAX_CURRENT_EDUCATIONS,
  APPROVE_ALL_EXPENSES_COUNT,
  languages,
  deleteModalConfigs,
  timesheetsStatuses,
  notificationStatuses,
  months,
  monthsShort,
  mobileWidth,
  appNotificationsTypes,
  appNotificationsConfigs,
  JOB_STATUS,
  maxMoneyValue,
  userExistConfig,
  jobAlerts,
  savedJobOptions,
  layoutResponsive,
  benefits,
  calendarTypes,
  globalPageSize,
  qtyToShowComment,
  qtyAllowedForComment,
  tAndEFilters,
  contractorFilters,
  approverFilters,
  contractorExpensesFilters,
  approverExpensesFilters,
  appAreas,
  appConfigVariableValues,
  imageFileTypes
};
